import { useProductsStore } from '@/stores/products'

export function getImageUrl (image, type = {}, height = null) {
  const store = useProductsStore();
  if (Array.isArray(image)) {
    image = { ...image }; // Convert array to object if needed
  }
  if (!image) {
    return null;
  }

  let queryString = '';
  if (type.width) {
    queryString += `w=${type.width}&`;
  }
  if (height !== null) {
    queryString += `h=${height}&`;
  } else if (type.height) {
    queryString += `h=${type.height}&`;
  }
  if (type.autocrop) {
    queryString += 'zs=1';
  }

  queryString = queryString ? `?${queryString}` : '';

  const url = `${store.domain.url}/image/${encodeURIComponent(image.id)}/${encodeURIComponent(image.name)}${queryString}`;
  // const url = image.url
  return url === 'undefined' && !url ? image.url : url;
}